'use client';

import { Center, HStack, Spinner } from '@chakra-ui/react';
import dynamic from 'next/dynamic';

import { ChatPaneCloseButton } from './ChatPaneCloseButton';

const renderLoading = (): React.ReactElement => (
  <Center p={4}>
    <Spinner />
  </Center>
);

const renderPaneLoading = (): React.ReactElement => (
  <>
    <HStack justify="end" p={2}>
      <ChatPaneCloseButton />
    </HStack>
    {renderLoading()}
  </>
);

export const ChatPane = dynamic(() => import('./ChatPaneContent').then((module) => module.ChatPane), {
  loading: renderPaneLoading,
});

export const MaterialChatExperience = dynamic(
  () => import('./ChatPaneContent').then((module) => module.MaterialChatExperience),
  { loading: renderLoading }
);
